'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

require('./ModalActionsList.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ModalActionsList = function ModalActionsList(_ref) {
    var actions = _ref.actions;
    return _react2.default.createElement(
        'ul',
        { className: 'ModalActionsList' },
        actions.map(function (action, index) {
            return _react2.default.createElement(
                'li',
                { key: index },
                _react2.default.createElement(
                    'a',
                    { href: action.href || '#', onClick: action.func },
                    action.text
                )
            );
        })
    );
};

// Styles
// Lib


ModalActionsList.propTypes = {
    actions: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        text: _propTypes2.default.string.isRequired,
        func: _propTypes2.default.func,
        href: _propTypes2.default.string
    }))
};

exports.default = ModalActionsList;


//////////////////
// WEBPACK FOOTER
// ./src/client/components/modal/ModalActionsList.js
// module id = 126
// module chunks = 0